var Request = require('./helper/request');

function Offering(app){
  var self = this;
  self.request = new Request(app);

  self.routes = {
    create: {
      url: '/service-offerings',
      method: 'POST'
    },
    index: {
      url: '/service-offerings',
      method: 'GET'
    }
  };
}

Offering.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, data);
};

Offering.prototype.index = function(data){
  var self = this;
  return self.request.get(self.routes.index.url);
};

module.exports = Offering;